module.exports = __webpack_public_path__ + "static/media/layer6-box.80f4a935.png";